import { useContext, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { SearchVehicleByParamsDataContext } from "../SearchVehicleByParamsDataProvider";
import { SearchVehicleByParamsDataContextType, SetSearchVehicleByParamsDataContextType } from "../types";

/**
 * Установка параметров из URL
 * @param {React.ReactNode} children - Дочерние компоненты
 * @returns {React.ReactNode}
 */
export const SetSearchParams = ({ children }: { children: React.ReactNode }) => {
    const [searchParams] = useSearchParams();
    const { brand, vehicleId, vehicleSsd, catalogSsd, setBrand, setVehicleId, setVehicleSsd, setCatalogSsd } = useContext(SearchVehicleByParamsDataContext) as SearchVehicleByParamsDataContextType & SetSearchVehicleByParamsDataContextType;

    useEffect(() => {
        const brandParam = searchParams.get('brand');
        const vehicleIdParam = searchParams.get('vehicleId');
        const vehicleSsdParam = searchParams.get('vehicleSsd');
        const catalogSsdParam = searchParams.get('catalogSsd');

        if (brandParam && brandParam !== brand) {
            setBrand(brandParam);
        }

        if (vehicleIdParam && vehicleIdParam !== vehicleId) {
            setVehicleId(vehicleIdParam);
        }

        if (vehicleSsdParam && vehicleSsdParam !== vehicleSsd) {
            setVehicleSsd(vehicleSsdParam);
        }

        if (catalogSsdParam && catalogSsdParam !== catalogSsd) {
            setCatalogSsd(catalogSsdParam);
        }
    }, []);

    return children;
};